import type { ModalNames } from "@apps/rewards/utils/modal/types";
import type { SdkMethodPayloadInterface } from "@modules/sdk/methods/SdkMethodPayloadInterface";

import { REWARDS_SDK_METHODS } from "../constants";
import type { OpenRewardsModalSdkMethodParams } from "../types";

class OpenRewardsModalSdkMethodPayload implements SdkMethodPayloadInterface {
    public readonly methodName: REWARDS_SDK_METHODS.OPEN_REWARDS_MODAL;

    constructor(
        public readonly modalName: ModalNames,
        public readonly params: OpenRewardsModalSdkMethodParams,
        public readonly onSuccess: (
            params: OpenRewardsModalSdkMethodParams
        ) => void,
        public readonly onError: (error: Error) => void
    ) {
        this.methodName = REWARDS_SDK_METHODS.OPEN_REWARDS_MODAL;
        this.modalName = modalName;
        this.params = params;
        this.onSuccess = onSuccess;
        this.onError = onError;
    }
}

export default OpenRewardsModalSdkMethodPayload;
